import { createContext } from "react";
import { IChat, IContext, IFilterMessagesTypes, IMessage, IMessagePost } from "../../types";

export const refetchInterval = 1000 * 60 * 5;

export const Context = createContext<IChat>({
    context: "chat" as IContext,
    other: undefined,
    userInfo: {} as any,
    error: "",
    editing: false,
    tab: 0,
    filter: {} as IFilterMessagesTypes,
    helpMode: false,
    setTab(v) { },
    setFilter(v) { },
    sendMessage(m, k) { },
    setForward(v) { },
    setError(v) { },
    setFilteredTopics: function (filter: string): void { },
    setReplyId: function (value: IMessage | IMessagePost | null): void { },
    closePopup: undefined,
});
